import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconMathEqualsCircle: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"math-equals-circle"} maskId="square-filled-radius-0-stroke-1-IconMathEqualsCircle"><path fillRule="evenodd" clipRule="evenodd" d="M2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12ZM8 10H16V11H8V10ZM8 13H16V14H8V13Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconMathEqualsCircle;
